import { render, staticRenderFns } from "./MarqiiPage.vue?vue&type=template&id=fad03380"
import script from "./MarqiiPage.vue?vue&type=script&lang=js"
export * from "./MarqiiPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports